export const server = "https://handraftshoppingapi.vercel.app/api/v2";
